module.exports = __webpack_public_path__ + "media/images/icons/SVG/008-a94706af6e60f766b00f1424e4fe1f4b.svg";